/**
 * 로그인이 만료됐을 때 — **작업 화면을 그대로 둔 채** 그 위에 로그인 창을 띄운다 (2026-09-14).
 *
 * 전에는 앱을 연 채로 QBase 세션이 끊기면 화면은 로그인 상태로 남고 모든 호출이 401 로 실패했다.
 * 로그인 화면은 새로고침해야만 떴다. 새로고침으로 보내면 결과 탭·실행 기록 같은 화면 상태가 사라진다.
 *
 * 그래서 App 을 내리지 않고 덮는다. 같은 계정으로 다시 들어오면 창만 닫히고 하던 일이 그대로 이어진다.
 * 다른 계정으로 들어오면 authActions.finishLogin 이 화면을 새로 불러온다 — 앞 사용자의 화면이 새 사용자에게
 * 보이면 안 된다. 판정(QBase 에 직접 확인)은 authActions.handleSessionExpired 가 한다.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import LoginPage from './LoginPage';
import './SessionExpiredGate.css';

export default function SessionExpiredGate() {
    const { t } = useTranslation();
    return (
        <div className="session-expired-overlay" role="dialog" aria-modal="true" aria-labelledby="session-expired-title">
            <div className="session-expired-notice" role="status">
                <strong id="session-expired-title">{t('auth:sessionExpired.title')}</strong>
                <span>{t('auth:sessionExpired.body')}</span>
            </div>
            <LoginPage />
        </div>
    );
}
